import { Outlet, Link, useLocation } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

const Footer = () => {

  return (
      <div className="footer">

<ScrollToTop />
        <Link to="/" className="navLogo">
            <img alt="MTS logo" src={"/images/branding/logoFull.svg"}/>
        </Link>
        <nav className="navbar container">
            <ul id="menu">
                <li>
                    <a href="#project-section">Crypto</a>
                </li>
                <li>
                    <a href="#project-section">Education</a>
                </li>
                <li>
                    <a href="#project-section">Services</a>
                </li>
                <li>
                    <a href="#meet-our-projects">Projects</a>
                </li>
                <li>
                    <a href="#meet-our-team">Team</a>
                </li>
                <li>
                    <a href="#contact">Contact</a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/guillermo-giudici/" className="footer-icon" target="_blank"><img alt="linkedin" src={"/images/icons/LinkedInFooter.svg"}/></a>
                </li>
            </ul>
        </nav>
      </div>
    );
  };
  
export default Footer;